import React from "react";

import { Gift, Phone } from "lucide-react";

import "./Banner.css";

const Banner = () => {
  return (
    <section className="offer-section">
      <div className="offer-container">
        {/* LEFT CONTENT */}

        <div className="offer-content">
          {/* GIFT ICON */}

          <div className="offer-icon">
            <Gift size={42} strokeWidth={2.5} />
          </div>

          {/* OFFER TEXT */}

          <div className="offer-text">
            <h2>ƯU ĐÃI ĐẶC BIỆT HÔM NAY</h2>

            <p>Giảm thêm phí cho khách hàng liên hệ sớm!</p>
          </div>
        </div>

        {/* CALL BUTTON */}

        <a href="tel:0941342598" className="offer-call">
          <Phone size={19} fill="white" />

          <span>GỌI NGAY: 0941 342 598</span>
        </a>
      </div>
    </section>
  );
};

export default Banner;
